import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const DialerKeypad = ({ onNumberChange, onCall, dialedNumber, isCallActive }) => {
  const [inputNumber, setInputNumber] = useState(dialedNumber || '');

  const keypadButtons = [
    { number: '1', letters: '' },
    { number: '2', letters: 'ABC' },
    { number: '3', letters: 'DEF' },
    { number: '4', letters: 'GHI' },
    { number: '5', letters: 'JKL' },
    { number: '6', letters: 'MNO' },
    { number: '7', letters: 'PQRS' },
    { number: '8', letters: 'TUV' },
    { number: '9', letters: 'WXYZ' },
    { number: '*', letters: '' },
    { number: '0', letters: '+' },
    { number: '#', letters: '' }
  ];

  const handleKeyPress = (key) => {
    if (isCallActive) return;
    
    const newNumber = inputNumber + key;
    setInputNumber(newNumber);
    onNumberChange(newNumber);
  };

  const handleBackspace = () => {
    if (isCallActive) return;
    
    const newNumber = inputNumber?.slice(0, -1);
    setInputNumber(newNumber);
    onNumberChange(newNumber);
  };

  const handleClear = () => {
    if (isCallActive) return;
    
    setInputNumber('');
    onNumberChange('');
  };

  const handleCall = () => {
    if (inputNumber?.trim()) {
      onCall(inputNumber);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-subtle border border-slate-200 p-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-4">Arama Paneli</h3>
        
        {/* Number Display */}
        <div className="bg-slate-50 rounded-lg p-4 mb-4 min-h-[60px] flex items-center justify-center">
          <span className="text-2xl font-mono text-slate-900 tracking-wider">
            {inputNumber || "Numara girin"}
          </span>
        </div>

        {/* Control Buttons */}
        <div className="flex items-center justify-center space-x-2 mb-6">
          <Button
            variant="outline"
            size="sm"
            onClick={handleBackspace}
            disabled={!inputNumber || isCallActive}
            iconName="Delete"
          />
          <Button
            variant="outline"
            size="sm"
            onClick={handleClear}
            disabled={!inputNumber || isCallActive}
            iconName="X"
          />
        </div>
      </div>
      {/* Keypad Grid */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        {keypadButtons?.map((button) => (
          <button
            key={button?.number}
            onClick={() => handleKeyPress(button?.number)}
            disabled={isCallActive}
            className={`h-16 rounded-lg border-2 border-slate-200 bg-white hover:bg-slate-50 hover:border-primary transition-all duration-150 flex flex-col items-center justify-center micro-hover micro-click focus-ring ${
              isCallActive ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <span className="text-xl font-semibold text-slate-900">{button?.number}</span>
            {button?.letters && (
              <span className="text-xs text-slate-500 font-medium">{button?.letters}</span>
            )}
          </button>
        ))}
      </div>
      {/* Call Button */}
      <div className="flex justify-center">
        <Button
          variant="success"
          size="lg"
          onClick={handleCall}
          disabled={!inputNumber?.trim() || isCallActive}
          iconName="Phone"
          iconPosition="left"
          className="w-full"
        >
          Ara
        </Button>
      </div>
    </div>
  );
};

export default DialerKeypad;